import { defineStyleConfig } from "@chakra-ui/react";

export const Text = defineStyleConfig({});
